// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Footer-module__footer__ZY65W{width:100%;padding:10px 0;color:#fff;background-color:#064785;position:absolute;bottom:0}.Footer-module__footer__ZY65W a{color:white}.Footer-module__footer__ZY65W a:hover{color:white}.Footer-module__footerAList__8tWHj>a{line-height:1rem;border-right:0.5px solid #fff;padding:0 0.5rem}.Footer-module__footerAList__8tWHj>a:last-child{border:0}\n", ""]);
// Exports
exports.locals = {
	"footer": "Footer-module__footer__ZY65W",
	"footerAList": "Footer-module__footerAList__8tWHj"
};
module.exports = exports;
